// removed by extract-text-webpack-plugin
module.exports = {"gwTileActionItem":"tile-action-hashed__gwTileActionItem__JnzYz"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/Actions/tile-action-hashed.scss
// module id = 716
// module chunks = 0